import { Typography } from "@mui/material";
import React from "react";

const Copyright = () => {
  return (
    <Typography variant="subtitle1" color="text.secondary">
      made by{" "}
      <a href="https://www.linkedin.com/in/prernanagpal4//" target="_blank" rel="noopener noreferrer" >
        Prerna Nagpal
      </a>{" "}
      &{" "}
      <a href="https://www.linkedin.com/in/yuvrajgupta0001/" target="_blank" rel="noopener noreferrer" >
        Yuvraj Gupta
      </a>
    </Typography>
  );
};

export default Copyright;